"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
exports.CarouselReducer = function (state, action) {
    switch (action.type) {
        case "PREV":
            var prev = state.current === 0 ? state.count - 1 : state.current - 1;
            return __assign(__assign({}, state), { current: prev });
        case "NEXT":
            var next = state.current === state.count - 1 ? 0 : state.current + 1;
            return __assign(__assign({}, state), { current: next });
        case "GOTO":
            return __assign(__assign({}, state), { current: action.data });
    }
    return state;
};
exports.Next = function () {
    return {
        type: "NEXT"
    };
};
exports.Prev = function () {
    return {
        type: "PREV"
    };
};
exports.Goto = function (num) {
    return {
        type: "GOTO",
        data: num
    };
};
exports.useCarousel = function (slideCount, initialSlide) {
    var _a = react_1.useReducer(exports.CarouselReducer, {
        current: initialSlide,
        count: slideCount
    }), state = _a[0], dispatch = _a[1];
    return {
        state: state,
        goTo: function (i) { return dispatch(exports.Goto(i)); },
        prev: function () { return dispatch(exports.Prev()); },
        next: function () { return dispatch(exports.Next()); }
    };
};
